import React from 'react';
import { Music } from 'lucide-react';

export default function AnnouncementBar() {
  const item = '27. November · Live Musik · ab 20 Uhr';
  const items = Array.from({ length: 8 });
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-9 bg-[#e0b49f] text-[#1a1410] overflow-hidden marquee-wrap">
      <div className="marquee-track h-9 items-center" style={{ animationDuration: '22s' }}>
        {items.map((_, i) => (
          <div key={i} className="flex items-center shrink-0">
            <Music size={14} className="mx-3" />
            <span className="text-xs sm:text-sm font-medium tracking-[0.14em] uppercase whitespace-nowrap">
              {item}
            </span>
            <span className="mx-5 text-[#8a5f4c]">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
